import {
  DEALER_DATA_AVAILABLE,
  RESET_SEARCH_TXN_ACCOUNT_DROPDOWNS,
  RESET_STORED_DEALER_ACCOUNT_IDS,
  RESET_STORED_PARENT_DEALER_ACCOUNT_IDS,
  RESET_STORED_SALESPERSON_NAMES,
  SET_STORED_DEALER_ACCOUNT_ID,
  SET_STORED_PARENT_DEALER_ACCOUNT_ID,
  SET_STORED_SALESPERSON_NAMES,
} from "../action";
import { searchTxnAccountDropdowns } from "./initial-store.js";

const initialState = searchTxnAccountDropdowns;

function setSearchTxnAccountDropdownReducer(state = initialState, action) {
  switch (action.type) {
    case SET_STORED_PARENT_DEALER_ACCOUNT_ID:
      return { ...state, storedParentDealerAccountIds: action.payload };
    case SET_STORED_DEALER_ACCOUNT_ID:
      return { ...state, storedDealerAccountIds: action.payload };
    case SET_STORED_SALESPERSON_NAMES:
      return { ...state, storedSalesPersonNames: action.payload };
    case RESET_STORED_PARENT_DEALER_ACCOUNT_IDS:
      return { ...state, storedParentDealerAccountIds: [] };
    case RESET_STORED_DEALER_ACCOUNT_IDS:
      return { ...state, storedDealerAccountIds: [] };
    case RESET_STORED_SALESPERSON_NAMES:
      return { ...state, storedSalesPersonNames: [] };
    case RESET_SEARCH_TXN_ACCOUNT_DROPDOWNS:
      return {
        ...state,
        storedParentDealerAccountIds: [],
        storedDealerAccountIds: [],
        storedSalesPersonNames: [],
      };
    case DEALER_DATA_AVAILABLE:
      return{
        ...state,
        dealerDataAvailable: true
      }
    default:
      return state;
  }
}

export default setSearchTxnAccountDropdownReducer;
